import { render, staticRenderFns } from "./cSocialSourceIcon.vue?vue&type=template&id=4a590484&"
import script from "./cSocialSourceIcon.vue?vue&type=script&lang=js&"
export * from "./cSocialSourceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports